/**
 * The time to wait on last keystroke before a mutation should be sent on change, in milliseconds.
 */
export const TEXT_MUTATION_DEBOUNCE_DURATION = 1000;

/**
 * The time to wait on last change before a mutation should be sent for multi-choice fields, in milliseconds.
 */
export const MULTI_CHOICE_MUTATION_DEBOUNCE_DURATION = 500;

/**
 * The time on change that a mutation definitely is sent, in milliseconds.
 *
 * This should be set to a large number, and is intended to prevent a lost mutation in edge cases.
 */
export const MUTATION_DEBOUNCE_MAX_DURATION = 30000;
